var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"className":"st0","points":"9.911,9.557 0.354,0 0,0.354 9.557,9.911 0,19.467 0.354,19.821 9.911,10.264 19.467,19.82 \n\t19.82,19.467 10.264,9.911 19.821,0.354 19.468,0 ","key":1})]);
}

Close.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 19.821 19.821","style":{"enableBackground":"new 0 0 19.821 19.821"},"xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
